import moment from 'moment';

export default {
  chartsData: {
    'hour-stats': { total: 0, growth: 0, points: [] },
    'day-stats': { total: 0, growth: 0, points: [] },
    'week-stats': { total: 0, growth: 0, points: [] },
    'month-stats': { total: 0, growth: 0, points: [] },
    'year-stats': { total: 0, growth: 0, points: [] },
    'unique-stats': { 'total-vs-unique': [] },
    'campaign-stats': { points: [[]] },
    'channel-type-stats': { points: [[]] },
    'heat-map-stats': { points: {}, range: [] },
  },
  mainChartData: {
    stats: { points: [] },
  },
  campaignReportData: {
    totals: {
      total_lifetime: 0,
      unique_lifetime: 0,
      total_today: 0,
      unique_today: 0,
      total_this_week: 0,
      unique_this_week: 0,
      total_this_month: 0,
      unique_this_month: 0,
      total_vs_unique_channel_type: [],
    },
    charts: {
      today: [],
      this_week: [],
      this_month: [],
      channels: [],
    },
  },
  selectedDate: moment(),
  selectedPeriod: 'year',
  selectedFilter: 'campaign',
  selectedTimeslot: 0,
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsError: null,
  loadingChartsSucceeded: false,
  loadingMainChart: false,
  loadingMainChartFailed: false,
  loadingMainChartError: null,
  loadingMainChartSucceeded: false,
  loadingCampaignReport: false,
  loadingCampaignReportFailed: false,
  loadingCampaignReportError: null,
  loadingCampaignReportSucceeded: false,

  campaignListChartsData: {},
  loadingCampaignListCharts: false,
  loadingCampaignListChartsFailed: false,
  loadingCampaignListChartsSucceeded: false,
  loadingCampaignListChartsError: null,

  showMainLegend: false,

  liveStreamingStates: {
    live_streams: 0,
    max_concurrent: 0,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/analytics/state.js